import actionTypes from "./_actions";
import * as utils from "common/utils";

const INITIAL_STATE = [];

function reducer(state = INITIAL_STATE, action) {
    let offlineFarms = [...state];

    switch (action.type) {
        case actionTypes.FERTILISER_SUBMIT: {
            const offlineFarm3 = utils.getOfflineFarm(offlineFarms, action.payload.farmId);
            if (!offlineFarm3) return state;
            const offlineBudget3 = utils.getOfflineBudget(offlineFarm3, action.payload.budgetId);
            if (!offlineBudget3) return state;
            if (!offlineBudget3.budget.fertiliser) offlineBudget3.budget.fertiliser = [];
            utils.merge(action.payload.fertiliser, offlineBudget3.budget.fertiliser);
            offlineBudget3.isDirty = true;
            return offlineFarms;
        }
        case actionTypes.FERTILISER_DELETE: {
            const offlineFarm4 = utils.getOfflineFarm(offlineFarms, action.payload.farmId);
            if (!offlineFarm4) return state;
            const offlineBudget4 = utils.getOfflineBudget(offlineFarm4, action.payload.budgetId);
            if (!offlineBudget4) return state;
            const fertiliser = offlineBudget4.budget.fertiliser.find((i) => i.id === action.payload.fertiliser.id);
            if (fertiliser) {
                offlineBudget4.budget.fertiliser.splice(offlineBudget4.budget.fertiliser.indexOf(fertiliser), 1);
                offlineBudget4.isDirty = true;
            }
            return offlineFarms;
        }
        case actionTypes.DCD_SUBMIT: {
            const offlineFarm5 = utils.getOfflineFarm(offlineFarms, action.payload.farmId);
            if (!offlineFarm5) return state;
            const offlineBudget5 = utils.getOfflineBudget(offlineFarm5, action.payload.budgetId);
            if (!offlineBudget5) return state;
            offlineBudget5.budget.nitrateInhibitors = action.payload.nitrateInhibitors;
            offlineBudget5.isDirty = true;
            return offlineFarms;
        }
        case actionTypes.DCD_DELETE: {
            const offlineFarm6 = utils.getOfflineFarm(offlineFarms, action.payload.farmId);
            if (!offlineFarm6) return state;
            const offlineBudget6 = utils.getOfflineBudget(offlineFarm6, action.payload.budgetId);
            if (!offlineBudget6) return state;
            offlineBudget6.budget.nitrateInhibitors = [];
            offlineBudget6.isDirty = true;
            return offlineFarms;
        }
        default:
            return state;
    }
}

export default reducer;
